import React from "react";
import PropTypes from "prop-types";
import { OverlayDrawer } from "@fluentui/react-components";
import { useResponsiveDrawerPosition } from "./responsive-drawer-utils";

export function ResponsiveOverlayDrawer({ desktopPosition = "end", mobilePosition = "bottom", ...props }) {
  const position = useResponsiveDrawerPosition({ desktopPosition, mobilePosition });

  return <OverlayDrawer {...props} position={position} />;
}

ResponsiveOverlayDrawer.propTypes = {
  desktopPosition: PropTypes.oneOf(["start", "end", "bottom"]),
  mobilePosition: PropTypes.oneOf(["start", "end", "bottom"])
};
